






























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue'
import SearchPanel from '@/components/common/modules/list/SearchPanel.vue';
import {
  ActionButtons,
  StatusActions
} from '@/services/hexabase/types'

@Component({
  components: { ActionButtonPanel, SearchPanel },
})
export default class ActionButtonWithSearchPanel extends Vue {

  @Prop({default: ''})
  private label?: string;
  // ステータスアクション情報格納配列
  // execAllowActionsからさらにユーザIDや現登録データを判定してボタンの活性非活性を定義したもの  
  @Prop({default: []})
  private statusButton?: Array<StatusActions>;
  // 現ステータスアクションと、現ステータスプレフィックスが定義されたデータ操作アクション
  @Prop({default: []})
  private execAllowActions?: Array<ActionButtons>;

  // 検索条件に表示するエレメント情報
  @Prop({ default: () => ([]) })
  private fieldData: any;
  // 検索のGridStyle値
  @Prop({ default: '' })
  private fieldCols: any;
  @Prop({ default: () => ({}) })
  private fieldTypes?: {[k: string]: string};

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに受け渡す
   * @module buttonAction
   * @param {string} type - 押下されたボタンのタイプ
   * @return {string} - 押下されたボタンのタイプ
   */
  @Emit('buttonActionRelay')
  private buttonActionRelay(type: string): string {
    return type;
  }

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに受け渡す
   * @module execSearchRelay
   * @param data - 子コンポーネントから渡されたデータ
   * @return data - 子コンポーネントから渡されたデータ
   */
  @Emit('execSearchRelay')
  private execSearchRelay(data: {[k: string]: string}) {
    return data;
  }

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに受け渡す
   * @module resetSearchFormRelay
   * @param data - 子コンポーネントから渡されたデータ
   * @return data - 子コンポーネントから渡されたデータ
   */
  @Emit('resetSearchFormRelay')
  private resetSearchFormRelay(data: {[k: string]: string}) {
    return data;
  }
}
